
















































































































































import VueStrong from '@/vueStrong';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import {CaptureEdge, CHMode, ClockSource, CountMode, Timer, TimerChannel, TimerIntMode, timersCount} from '@/store/timer32/types';

import Tabs from '@/components/standart/Tabs.vue';
import VCheckbox from '@/components/standart/VCheckbox.vue';
import Multiselect from 'vue-multiselect';
import { Timer32Mutations } from '@/store/timer32/mutations';

@Component({
  components: {
    Tabs,
    VCheckbox,
    Multiselect,
  },
})
export default class Timer32Properties extends VueStrong {

  get countModes(): string[] {
    return Object.keys(CountMode);
  }

  get clockSources(): string[] {
    return Object.keys(ClockSource);
  }

  get intModes(): string[] {
    return Object.keys(TimerIntMode);
  }

  get chModes(): string[] {
    return Object.keys(CHMode);
  }

  get captureEdges(): string[] {
    return Object.keys(CaptureEdge);
  }

  get tabNames(): string[] {
    return [...Array(timersCount).keys()].map(e=>`Timer32_${e}`);
  }

  public CHMode = CHMode;

  selected = 0;

  isAnimating = false;
  animTimer: number|null = null;

  @Watch('selected')
  onSelectedChange():void {
    if (this.animTimer !== null) return;

    this.isAnimating = true;
    this.animTimer = setTimeout(()=>{
      this.isAnimating = false;
      this.animTimer = null;
    }, 150);
  }

  constructor() {
    super();
  }

  get timers(): Timer[] {
    console.log(this.$store.state);
    return this.$store.state.timer32.timers;
  }

  changeTimerChannel(timer: number, channel: number, data: Partial<TimerChannel>): void {
    const channels = this.$store.state.timer32.timers[timer].channels.map((e,i)=>{
      if (i === channel) {
        return {
          ...e,
          ...data,
        };
      }
      return { ...e };
    });

    this.$store.commit(Timer32Mutations.CHANGE_TIMER_DATA, {
      data: {
        channels,
      },
      index: timer,
    });
  }

  changeTimer(index: number, data: Partial<Timer>): void {
    if (data.top) {
      data.top = Math.floor(data.top);
    }
    if (data.prescaler) {
      data.prescaler = Math.floor(data.prescaler);
    }

    this.$store.commit(Timer32Mutations.CHANGE_TIMER_DATA, {
      data: {
        ...data,
      },
      index,
    });
  }
}
